import { t as u } from "./morphNodes-BUJqEfyn.js";
import { t as p } from "./cacheFetch-DVg5INtU.js";
var E = () => ({
  productSoldOut: !1,
  hasRequired: !0,
  controller: new AbortController(),
  checkRequired(e) {
    const t = new FormData(e);
    this.hasRequired = e.elements.toArray().filter((r) => r instanceof HTMLInputElement || r instanceof HTMLSelectElement || r instanceof HTMLTextAreaElement).filter((r) => r.required && r.name?.endsWith("[id]")).map((r) => t.get(r.name)).every((r) => r && r !== "null");
  },
  init() {
    const e = this.$el.querySelector("form[action='/cart/add']");
    e?.addEventListener("change", () => {
      this.checkRequired(e);
    }, { signal: this.controller.signal }), e && this.checkRequired(e);
  },
  destroy() {
    this.controller.abort();
  },
  async changeVariant(e) {
    console.log("Replacing page with:", e);
    const t = new URL(e, window.location.origin);
    window.history.replaceState({}, "", t);
    const r = await p(t);
    if (!r) {
      console.error("Failed to fetch the new variant page:", e);
      return;
    }
    const i = this.$el.closest('section[id^="shopify-section"]');
    if (!i) {
      console.warn("No current section found for variant change");
      return;
    }
    u(r, `#${i.id}`);
  }
}), _ = () => ({ async handleSubmit(e) {
  if (window.NewThink?.ACCESS_GATE_CAN_BUY === !1) {
    window.location.href = window.NewThink.ACCESS_GATE_LOGIN_URL ?? "/account/login";
    return;
  }
  if (!e.reportValidity()) return;
  const t = new FormData(e);
  if (Array.from(t.entries()).filter(l(y)).filter(([n, s]) => s === "").forEach(([n]) => t.delete(n)), t.has("items[0][properties][_bundle_parent]")) {
    const n = Array.from(t.entries()).filter(l("[id]")).map(([o, a]) => a).map(String), s = await A(n.filter((o) => o !== "" && o !== "null")), m = parseInt(t.get("items[0][quantity]")) || 1;
    n.forEach((o, a) => {
      o === "" || o === "null" ? Array.from(t.keys()).filter(f(`items[${a}]`)).forEach(t.delete.bind(t)) : (t.append(`items[${a}][properties][_bundle_id]`, s), t.has(`items[${a}][quantity]`) || t.append(`items[${a}][quantity]`, m.toString()));
    });
  }
  const r = Array.from(e.elements).find((n) => n.id.startsWith("product-notes-"));
  Array.from(t.entries()).filter(l("[quantity]")).filter(([n, s]) => s === "0").map(d("[quantity]")).forEach((n) => Array.from(t.keys()).filter(f(n)).forEach(t.delete.bind(t)));
  const i = t.get("selling_plan"), c = Array.from(t.keys()).filter((n) => /^items\[\d+\]\[id\]$/.test(n)).map((n) => n.slice(0, -4));
  i !== null && c.length > 0 && (t.delete("selling_plan"), i !== "" && c.forEach((n) => t.set(`${n}[selling_plan]`, String(i)))), r?.value && Array.from(t.entries()).filter(l("[id]")).map(d("[id]")).map(g(r.name.match(/\[properties\]\[.+\]/)?.[0])).forEach((n) => {
    t.append(n, r.value);
  });
  const h = await fetch(e.action + ".js", {
    method: e.method,
    body: t
  });
  if (!h.ok) {
    console.error("Failed to submit form:", h.statusText);
    return;
  }
  this.$store.cart.isOpen ? this.$store.cart.load() : this.$store.cart.open();
} }), b = () => ({
  controller: new AbortController(),
  hasQuantity: !1,
  init() {
    const e = this.$el.form;
    console.assert(e, "LockedATC must be initialized on a button in a form"), e?.addEventListener("change", () => {
      this.checkQuantity(e);
    }, { signal: this.controller.signal }), e && this.checkQuantity(e);
  },
  checkQuantity(e) {
    const t = Array.from(new FormData(e).entries()).filter(([r]) => r.endsWith("[quantity]"));
    if (t.length === 0) {
      this.hasQuantity = !0;
      return;
    }
    this.hasQuantity = t.map(([, r]) => Number(r)).some((r) => r > 0);
  },
  destroy() {
    this.controller.abort();
  }
}), y = [
  "[Send on]",
  "[Message]",
  "[selling_plan]"
], l = (e) => ([t]) => Array.isArray(e) ? e.some((r) => t.endsWith(r)) : t.endsWith(e), d = (e) => ([t]) => Array.isArray(e) ? e.reduce((r, i) => r.endsWith(i) ? r.slice(0, -i.length) : r, t) : t.endsWith(e) ? t.slice(0, -e.length) : t, g = (e = "") => (t) => t + e, f = (e) => (t) => t.startsWith(e), A = async (e) => {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e.toSorted().join("-")));
  return Array.from(new Uint8Array(t)).map((r) => r.toString(16).padStart(2, "0")).join("");
};
Array.prototype.toSorted ??= function(e) {
  return [...this].sort(e);
};
HTMLFormControlsCollection.prototype.toArray ??= function() {
  return Array.from(this);
};
export {
  b as LockedATC,
  _ as ProductForm,
  E as ProductMain,
  E as default
};
